export const environment = {
  production: true,
  backendUrl: 'https://apiv1.deebr.co',
  anyChartLicenseKey: 'deebr.co-33feeffe-90c45ceb',
};
